import { useSelector } from 'react-redux';
import { userSubscription } from '../../store/sales/selectors';

export default function useGetSubscription() {
    const subscription = useSelector((state) => userSubscription(state));

    return subscription;
}
